import { ROLES } from '../utils/roles';

// Reads the current customer admin's role from localStorage (set at login in App.js).
// Role is stable for the session, so a plain read per render is sufficient.
export const getAdminRole = () => {
  try {
    const raw = localStorage.getItem('adminDetails');
    if (!raw) return null;
    return JSON.parse(raw).role || null;
  } catch {
    return null;
  }
};

// True when the logged-in customer admin has read-only access to the Prism admin portal.
export const isReadOnlyAdmin = () => getAdminRole() === ROLES.READ_ONLY;

// Hook form for use inside components.
export const useReadOnlyMode = () => isReadOnlyAdmin();
